export const mapToUINotification = ({
  _id,
  state,
  feeName,
  oldValue,
  newValue,
  read,
  date
}) => ({
  id: _id,
  title: `${state.toUpperCase()}: ${feeName} fee has been ${
    oldValue ? "updated" : "created"
  }.`,
  content: oldValue
    ? `From $${oldValue} to $${newValue}.`
    : `Fee value is $${newValue}`,
  read,
  createdAt: new Date(date)
});

export const mapToCustomNotification = ({
  _id,
  state,
  subject,
  description,
  read,
  date
}) => ({
  id: _id,
  htmlContent:
    (state
      ? `<div>${state.toUpperCase()}: ${subject}</div>`
      : `<div>${subject}</div>`) + description,
  read,
  createdAt: new Date(date),
  type: "custom"
});
